import { Fragment, ReactNode } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { ComputeFieldComponent } from "../../computeFields";

export const SeparatedList: ComputeFieldComponent<
  ReactNode[],
  {
    commaSeparated?: boolean;
  }
> = ({ input, lineBreak, endWithPeriod = false, commaSeparated = true }) => {
  if (!input || input.length === 0) {
    return "";
  }
  const elements = input
    .filter((element) => element != null)
    .filter((element) => element !== false)
    .filter((element) => {
      if (typeof element !== "object") return true;
      return renderToStaticMarkup(element).trim() !== "";
    })
    .filter(
      (element) => !(typeof element === "string" && element.trim() === ""),
    );

  return (
    <>
      {elements.map((element, index) => {
        const lastElement = index === elements.length - 1;
        return (
          <Fragment key={index}>
            {element}
            {!lastElement && lineBreak && <br />}
            {!lastElement && !lineBreak && commaSeparated && <>, </>}
            {!lastElement && !lineBreak && !commaSeparated && <> </>}
            {lastElement &&
              endWithPeriod &&
              !(typeof element === "string" && element.endsWith(".")) && <>.</>}
          </Fragment>
        );
      })}
    </>
  );
};
